module.exports = __webpack_public_path__ + "img/company-info.30372a02.svg";